import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { map, tap, withLatestFrom } from 'rxjs';
import { PagePath } from '../enums/page-path.enum';
import { GuardsContextService } from '../services/guards-context.service';
import { NavigationService } from '../services/navigation.service';
import { PlansStateService } from '../services/plans-state.service';

export const selectedPlanGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  guardsContextService = inject(GuardsContextService),
  plansStateService = inject(PlansStateService),
  navigationService = inject(NavigationService)
) => {
  return guardsContextService.getIsProcessingAuth$().pipe(
    withLatestFrom(plansStateService.hasSelectedPlan$()),
    tap(([isProcessingAuth, hasSelectedPlan]) => {
      if (!isProcessingAuth && !hasSelectedPlan) {
        navigationService.navigateToPagePath([PagePath.SELECT_PLAN]);
      }
    }),
    map(([isProcessingAuth, hasSelectedPlan]) => isProcessingAuth || hasSelectedPlan)
  );
};
